import { create } from 'zustand'
import { getEnums, type EnumsResponse } from '@/api/enums'

interface EnumsState {
  enums: EnumsResponse | null
  isLoading: boolean
  error: string | null
  loadEnums: () => Promise<void>
  clearEnums: () => void
}

export const useEnumsStore = create<EnumsState>((set, get) => ({
  enums: null,
  isLoading: false,
  error: null,
  loadEnums: async () => {
    if (get().isLoading) return
    set({ isLoading: true, error: null })
    try {
      const enums = await getEnums()
      set({ enums, isLoading: false })
    } catch (e) {
      const message = e instanceof Error ? e.message : 'Failed to load enums'
      set({ error: message, isLoading: false, enums: null })
    }
  },
  clearEnums: () => set({ enums: null, error: null }),
}))
